import React from 'react';

const Help = () => {
  return (
    <div className="max-w-4xl mx-auto p-6 text-gray-800 dark:text-gray-100">
      <h1 className="text-3xl font-bold mb-4">📘 Help Guide: Blog & News Manager</h1>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">🌟 What Is This System?</h2>
        <p>
          This dashboard lets Q AND E Consultancy administrators create, edit, and manage blog posts and news updates.
          All changes made here will reflect instantly on the public website. No coding required — just log in, click, and manage content with confidence.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">🧭 Who Is It For?</h2>
        <p>
          This system is for Q AND E Consultancy administrators. It provides full control over the blog and news sections of the main website.
          <strong className="block mt-2 text-red-500">⚠️ Any changes made here will affect the public website. Deleting anything in this dashboard its permanent meaning we cannot recover. Please review your edits carefully.</strong>
        </p>
      </section>

      
      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">🖼️ Step 1: Upload Your Image</h2>
        <ul className="list-disc ml-6">
          <li>Go to <a href="https://cloudinary.com" className="text-blue-500 underline" target="_blank" rel="noopener noreferrer">Cloudinary</a></li>
          <li>Log in using the provided credentials ( username : qandeconsultancy243@outlook.com , password : Qandeconsultancy@25 ) </li>
          <li>Navigate to Assets , then click the upload button </li>
          <li>Upload your image</li>
          <li>Copy the image link (URL ending in <code>.jpg</code>, <code>.png</code>, etc.)</li>
        </ul>
        <img src="https://res.cloudinary.com/dkckmwfqj/image/upload/v1760992158/cloud1_sichii.png" alt="Cloudinary Upload Screenshot" className="mt-4 rounded shadow-md" />
        <img src="https://res.cloudinary.com/dkckmwfqj/image/upload/v1760992159/cloud2_rlkrtc.png" alt="Cloudinary Upload Screenshot" className="mt-4 rounded shadow-md" />
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">📝 Step 2: Create a Blog or News Post</h2>
        <ul className="list-disc ml-6">
          <li>Click <strong>Create Blog</strong> or <strong>Create News</strong></li>
          <li>Fill in the form: Title, Description, Image URL</li>
          <li> On image URL you Paste the URL link which you copied from step 1 </li>
          <li>Click <strong>Submit</strong> your post will appear on the public website</li>
        </ul>
        <img src="https://res.cloudinary.com/dkckmwfqj/image/upload/v1760992159/create1_vrtl90.png" alt="Create Post Screenshot" className="mt-4 rounded shadow-md" />
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">🧾 Step 3: View Active Posts</h2>
        <ul className="list-disc ml-6">
          <li>Click <strong>View Blogs</strong><strong>View News</strong></li>
          <li>See which posts are currently live</li>
          <li>Edit or delete posts as needed by clicking either the pencil for editing or the Basket button which is delete </li>
        </ul>
        <img src="https://res.cloudinary.com/dkckmwfqj/image/upload/v1760992157/create2_dc88zk.png" alt="View Posts Screenshot" className="mt-4 rounded shadow-md" />
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">💡 Tips for Responsible Use</h2>
        <ul className="list-disc ml-6">
          <li>Double-check your image URL and post content before submitting</li>
          <li>Use clear, professional language  this content is public</li>
          <li>Log out when you're done to keep your account secure</li>
        </ul>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-2">📞 Need Help?</h2>
        <p>
          If you run into any issues, contact the system administrator or reach out to Q AND E Consultancy support.
        </p>
      </section>
    </div>
  );
};

export default Help;